import React, { useEffect, useState, Fragment } from "react";
import { IconButton } from "@mui/material";
import { ReactMic } from "react-mic";
import SendIcon from "@mui/icons-material/Send";
import DeleteIcon from "@mui/icons-material/Delete";
import PauseIcon from "@mui/icons-material/Pause";

function VoiceRecorder({
  startRecording,
  setshowVoiceMessageComponent,
  onSendVoiceMessage,
  recording,
  setRecording
}) {

  const [audioBlob, setAudioBlob] = useState(null);
  const [showPreview, setShowPreview] = useState(false);

  useEffect(() => {
    setRecording(startRecording);
    return () => {
      setRecording(false);
    };
  }, [startRecording]);

  const onStop = (recordedBlob) => {
    setAudioBlob(recordedBlob);
  };

  const handleDirectSend = () => {
    if (recording) {
      // Stop recording first, then send the audio in the onStop callback
      setRecording(false);
      setShowPreview(false); // Hide preview for direct send
    } else if (audioBlob) {
      // If recording is already stopped, send the audio immediately
      onSendVoiceMessage(audioBlob.blobURL);
      setshowVoiceMessageComponent(false);
      setAudioBlob(null);
    }
  };

  const handlePause = () => {
    setRecording(false); // Stop recording
    setShowPreview(true); // Show the audio preview
  };

  const handleSendPreview = () => {
    if (audioBlob) {
      onSendVoiceMessage(audioBlob.blobURL); // Send the audio from the preview
      setshowVoiceMessageComponent(false); // Hide the voice message component
      setAudioBlob(null); // Clear the recorded audio
    }
  };

  const deleteRecording = () => {
    setAudioBlob(null); // Clear the recorded audio
    setRecording(false); // Stop recording
    setshowVoiceMessageComponent(false); // Hide the voice message component
  };

  // Handle sending after recording stops
  useEffect(() => {
    if (!recording && audioBlob && !showPreview) {
      // If recording is stopped and preview is not shown, send the audio directly
      onSendVoiceMessage(audioBlob.blobURL);
      setshowVoiceMessageComponent(false);
      setAudioBlob(null);
    }
  }, [
    recording,
    audioBlob,
    showPreview,
    onSendVoiceMessage,
    setshowVoiceMessageComponent,
  ]);

  return (
    <Fragment>
      {showPreview && audioBlob ? (
        // Show the audio preview and options to delete or send
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <IconButton onClick={deleteRecording} color="error">
            <DeleteIcon />
          </IconButton>
          <audio controls controlsList="nodownload" src={audioBlob.blobURL} />
          <IconButton onClick={handleSendPreview} sx={{ color: "#25D366" }}>
            <SendIcon />
          </IconButton>
        </div>
      ) : (
        // Show the recording controls
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <IconButton onClick={handlePause}>
            <PauseIcon />
          </IconButton>
          <ReactMic
            record={recording}
            onStop={onStop}
            noiseSuppression
            mimeType="audio/webm" // Ensure the correct format
            className="hidden"
            width={200}
            height={30}
          />

          <IconButton onClick={handleDirectSend} sx={{ color: "#25D366" }}>
            <SendIcon />
          </IconButton>
        </div>
      )}
    </Fragment>
  );
}

export default VoiceRecorder;
